/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import GlobalScope from '../globalScope/GlobalScope';

export default class Environment {
  static getEnvironmentFromUrl(url: string): string {
    try {
      const baseURL = new GlobalScope.value.URL(url);

      return baseURL.origin;
    } catch (e) {
      return '';
    }
  }
}